import { globalStore } from '@gto/gw-store'

export interface BeforeInstallPromptEvent extends Event {
  readonly platforms: string[]
  readonly userChoice: Promise<{
    outcome: 'accepted' | 'dismissed'
    platform: string
  }>
  prompt(): Promise<void>
}

export const beforeInstallPromptListener = (e: BeforeInstallPromptEvent) => {
  e.preventDefault()
  globalStore.getState().setDeferredPrompt(e)
}

export const installApp = async () => {
  const installPwaPrompt = globalStore.getState().installPwaPrompt
  if (!installPwaPrompt) return
  installPwaPrompt.prompt()
}
